import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Customerdeal } from '@src/app/models/customerdeal';
import { ActivatedRoute } from '@angular/router';
import { Project } from '@src/app/models/project';
import { CustomerdeallistService } from './service/customerdeallist.service';
import { DatastoreService } from '@src/app/helpers/datastore/datastore.service';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-customerdeallist',
  templateUrl: './customerdeallist.component.html',
  styleUrls: ['./customerdeallist.component.css']
})
export class CustomerdeallistComponent {
  customerId:string;
  dealList:Customerdeal[];
  dealProjects:Project[];
  modalDeal:Customerdeal;
  showSpinner:boolean=false;
  showDeleteConfirm:boolean;
  dealtoggler:string = null;
  @ViewChild('closedealmodal',{static: true}) closedealmodal: ElementRef;
  @ViewChild('deletemodalclose',{static: true}) deletemodalclose: ElementRef;
  @Output() projecttoadd = new EventEmitter<Project>();

  constructor(
    private cdsrv:CustomerdeallistService,
    private route:ActivatedRoute,
    private datastore:DatastoreService,
    ){}
  
  ngOnInit(): void {
    
    this.customerId = this.route.snapshot.paramMap.get('customerId').split('_')[0];
    this.modalDeal=new Customerdeal();
    let now = new Date().toISOString();
    this.cdsrv.getDeals(this.customerId,now).pipe(untilDestroyed(this)).subscribe(data=>{
      this.dealList=data;
      //console.log('deals',this.dealList);
      //count number of projects
      this.dealList.forEach(deal=>{
        
        //this.cdsrv.getProjects(this.customerId,now).pipe(untilDestroyed(this)).subscribe(data=>{
          this.datastore.projectList$.pipe(untilDestroyed(this)).subscribe(data=>{
          this.dealProjects=[];
          data.forEach(project=>{
            if(project.dealId !=undefined && project.dealId.split('_')[0]==deal.dealId.split('_')[0]){
              this.dealProjects.push(project); 
            }
          });
          deal.projectCount=this.dealProjects.length;
        });
      }
     );
  });
}

//deal action toggler
toggleactions(deal:Customerdeal){
  if (this.dealtoggler!=null){
    this.dealtoggler=null;
    this.modalDeal=new Customerdeal();
  }else{
    this.dealtoggler=deal.dealId;
    this.modalDeal=deal;
  } 
}
  //add deal project
  addDealProject(project:Project){
    this.dealList.find(deal=>deal.dealId==project.dealId).projectCount++; 
    this.projecttoadd.emit(project);
  }

  //Add deal
  addDeal(){
    this.showSpinner=true;
    this.modalDeal.customerId=this.customerId;
    this.cdsrv.createDeal(this.modalDeal).pipe(untilDestroyed(this)).subscribe(data=>{
      this.modalDeal.dealId=data.dealId;
      this.dealList.push(this.modalDeal);
      this.modalDeal=new Customerdeal();
      this.showSpinner=false;
    }
    );
  }
  openDeal(deal:Customerdeal){
    this.modalDeal=deal;
    this.modalDeal.customerId=this.customerId;
  }

  //Update deal
  updateDeal(){
    this.showSpinner=true;
    this.cdsrv.updateDeal(this.modalDeal).pipe(untilDestroyed(this)).subscribe(data=>{
      this.dealList.forEach((deal,index)=>{
        if(deal.dealId==this.modalDeal.dealId){
          this.modalDeal.dealId=data;
          this.dealList[index]=this.modalDeal;
        }
      } );
      this.modalDeal=new Customerdeal();
      this.closedealmodal.nativeElement.click();
      this.showSpinner=false;
    });
  }

  //Delete deal
  deleteDeal(){
    this.showSpinner=true;
    this.cdsrv.deleteDeal(this.modalDeal).pipe(untilDestroyed(this)).subscribe(data=>{
      this.dealList.forEach((deal,index)=>{
        if(deal.dealId==this.modalDeal.dealId){
          this.dealList.splice(index,1);
        }
      } );
      this.modalDeal=new Customerdeal();
      this.deletemodalclose.nativeElement.click();
      this.showSpinner=false;
    });
  }

}
